import { ROUTE } from "../../routes";
import { ApplicationPendingContext } from "@voltmoney/schema";
import { api } from "../../configs/api";
import sharedPropsService from "../../SharedPropsService";
import { getAppHeader } from "../../configs/config";
export const contactUs = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.CONTACT_US_CARD);
};
export const navAction = async (action, _datastore, { navigate, network }) => {
    const context = action.payload.context;
    const user = await sharedPropsService.getUser();
    const applicationId = user?.linkedApplications[0]?.applicationId;
    const currentStepId = user?.linkedApplications[0]?.currentStepId;
    let resetResponse = undefined;
    if (context === ApplicationPendingContext.KYC_MISMATCH
        || context === ApplicationPendingContext.BANK_MISMATCH
        || context === ApplicationPendingContext.PHOTO_MISMATCH) {
        resetResponse = await network.get(`${api.resetStepAfterReview}${applicationId}/${currentStepId}`, {
            headers: await getAppHeader()
        });
    }
    if (resetResponse && resetResponse.status === 200) {
        switch (context) {
            case ApplicationPendingContext.KYC_MISMATCH:
                await navigate(ROUTE.KYC_DOCUMENTS_DIGIO_BASE);
                break;
            case ApplicationPendingContext.BANK_MISMATCH:
                navigate(ROUTE.BANK_ACCOUNT_VERIFICATION);
                break;
            case ApplicationPendingContext.PHOTO_MISMATCH:
                navigate(ROUTE.KYC_STEPPER);
                break;
        }
    }
};
